import React from 'react';
import withMemoRef from '../../utils/withMemoRef';
/**
 * TabContent component.
 *
 * @param props TabContent properties.
 */
export const TabContent = withMemoRef('TabContent', (props, ref) =>
  React.createElement(
    'section',
    Object.assign(
      { role: 'tabpanel' },
      Object.assign(Object.assign({}, props), { ref })
    )
  )
);
export default TabContent;
